import * as React from "react";
import SearchDropdownFilter from "./SearchDropdownFilter";
import {PaymentMethod} from "../../../model/payment/Payment";

export class PaymentMethodFilter extends SearchDropdownFilter<string> {

	itemToId(item: string): string {
		return item;
	}

	itemToLabel(item: string): string {
		return PaymentMethod[item as any];
	}
}
